/*
 * File: form-cell.ts
 * File Created: 2024-09-13 12:36:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-06 06:23:59
 * Modified By: Val Liu
 * -----
 */

import { BaseFormComponent } from "@root/components/form/core/lib/base-form-component";
import { UITag } from "@root/core/tags";
import { IQuickUnitAny } from "@root/core/utilities/quick-helper";
import { PropInnateSync } from "@root/core/vue-props";
import { Component, Prop } from "vue-property-decorator";

/// Val: should not directly use it.
/// purpose: show up a cell inside a form.
/// use it via @uiFormCellType
@Component
@UITag.setDefault({
    /// put cell as form element, ignore submit.
    uiSubmitIgnore: true,
})
export default class FormCell extends BaseFormComponent {
    @PropInnateSync("value", { default: undefined })
    innateValue!: NonNullable<any> | undefined;

    /// the cell to use.
    /// ex: iv-cell-string
    @Prop({ type: String, required: true })
    cell!: string;
}
